import { useEffect, useState } from 'react';
import { fetchAdminsService, fetchUsersService, addAdminService, removeAdminService } from '../../services/users/assignAdminsService.js';

export const useAssignAdmins = () => {
    const [admins, setAdmins] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [searchUserTerm, setSearchUserTerm] = useState('');
    const [searchAdminTerm, setSearchAdminTerm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isAddDisabled, setIsAddDisabled] = useState(true);
    const [isRemoveDisabled, setIsRemoveDisabled] = useState(true);

    const loadData = async () => {
        const adminsData = await fetchAdminsService();
        const usersData = await fetchUsersService();

        setAdmins(adminsData.sort((a, b) => a.name.localeCompare(b.name)));
        setUsers(usersData.sort((a, b) => a.name.localeCompare(b.name)));
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (!selectedUserId) {
            setIsAddDisabled(true);
            setIsRemoveDisabled(true);
            return;
        }

        const isAdmin = admins.some(a => a.id === Number(selectedUserId));
        setIsAddDisabled(isAdmin);
        setIsRemoveDisabled(!isAdmin);
    }, [selectedUserId, admins]);

    // Añadir un usuario como administrador
    const addAdmin = async () => {
        if (!selectedUserId) {
            setError('Por favor, selecciona un usuario.');
            return;
        }

        try {
            const res = await addAdminService(selectedUserId);
            setSuccess(res.message);
            setSelectedUserId(null);
            setSearchUserTerm('');
            await loadData();
        } catch (err) {
            setError(err.response?.data?.message || 'Error al añadir administrador.');
        }
    };

    // Quitar un usuario como administrador
    const removeAdmin = async () => {
        if (!selectedUserId) {
            setError('Por favor, selecciona un usuario.');
            return;
        }

        try {
            const res = await removeAdminService(selectedUserId);
            setSuccess(res.message);
            setSelectedUserId(null);
            setSearchAdminTerm('');
            await loadData();
        } catch (err) {
            setError(err.response?.data?.message || 'Error al quitar administrador.');
        }
    };

    const filteredUsers = users.filter(u =>
        `${u.name} ${u.lastname}`.toLowerCase().includes(searchUserTerm)
    );
    const filteredAdmins = admins.filter(a =>
        `${a.name} ${a.lastname}`.toLowerCase().includes(searchAdminTerm)
    );

    const resetMessages = () => {
        setError('');
        setSuccess('');
    };

    return {
        admins: filteredAdmins,
        users: filteredUsers,
        selectedUserId,
        setSelectedUserId,
        searchUserTerm,
        searchAdminTerm,
        setSearchUserTerm,
        setSearchAdminTerm,
        addAdmin,
        removeAdmin,
        isAddDisabled,
        isRemoveDisabled,
        error,
        success,
        resetMessages
    };
}